(function() {
  "use strict";

  angular.module("cosmicRadiation").config(config);

  function config($stateProvider) {
    $stateProvider.state("cosmicRadiation", {
      url: "/cosmic-radiation",
      views: {
        cosmicRadiationView: {
          templateUrl: "cosmic-radiation/views/cosmic-radiation.tpl.html",
          controller: "CosmicRadiationCtrl",
          controllerAs: "cosmicRadiation"
        }
      }
    });
  }
})();
